<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="d7e94">
<h1 class="chapno">
</h1><h2 class="chapttl" id="d7e95">
<i>Acknowledgments</i>
</h2>
<p class="tx1" id="d7e98">So many people helped make this book a reality, and we would like to extend our profound and sincere gratitude to each of them.</p>
<p class="tx1" id="d7e100">The following people are key contributors to both AskDan <a href="http://AndJennifer.com" target="_blank">AndJennifer.com</a> and this book. Their knowledge, skills, and wisdom help us all.</p>
<p class="tx1" id="d7e105">Kaylen Shubrick, our amazing writer and editor who helps turn our thoughts and videos into words.</p>
<p class="tx1" id="d7e107">Paul Carlson (<i><a href="http://www.PersonalChanges.com" target="_blank">www.PersonalChanges.com</a></i>), life coach and CCHt (Certified Clinical Hypnotherapist). His background provides him with a unique ability to provide guidance and coaching for those who want a better, happier, and more successful personal and business life.</p>
<p class="tx1" id="d7e113">Melody Brooke (<i><a href="http://www.ThisIsGreatSex.com" target="_blank">www.ThisIsGreatSex.com</a></i>), Professional and Marriage and Family Counselor, international speaker, author, and founder of <a href="http://ThisIsGreatSex.com" target="_blank">ThisIsGreatSex.com</a>.</p>
<p class="tx1" id="d7e122">The Beautiful Kind (<i><a href="http://www.TheBeautifulKind.com" target="_blank">www.TheBeautifulKind.com</a></i>), kink expert, sex writer, and consultant, as well as a sex worker specializing in fetishes and surrogacy (a sexual surrogate is someone who helps others overcome social and sexual issues through hands-on intimacy).</p>
<p class="tx1" id="d7e128">In addition, we would like to thank the following people for making this book possible:</p>
<p class="tx1" id="d7e130">Neil Salkind (<i><a href="http://www.studiob.com/salkindagency" target="_blank">www.studiob.com/salkindagency</a></i>), our amazing literary agent; and all of the amazing people at Adams Media (<i><a href="http://www.adamsmedia.com" target="_blank">www.adamsmedia.com</a></i>), our publisher, for their incredible help and support while writing this book.</p>
<p class="tx1" id="d7e140">And last, but not least, we extend our profound thanks to you for reading this book. We hope you have as much fun reading it as we did writing it!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9781440506963_epub_ack.vue?258e80e3